export default Object.freeze({
  AMEX: 'American Express',
  MASTERCARD: 'Mastercard',
  PAYPAL: 'PayPal',
  VISA: 'Visa',
});
